import { createTheme } from "@mui/material/";
import { breakpoints } from "./breakpoints";
import { palette, BLACK, BLUE_MAIN, GRAY_MAIN, WHITE, GRAY_LIGHT, BLUE_LIGHT, GREEN_LIGHT, BLUE_DARK, GREEN_MAIN, GREEN_LOGO } from "./colors";
import { spacing } from "./spacing";
import { fontWeightClasses, typography, roboto} from "./typography";
import type {} from '@mui/x-date-pickers/themeAugmentation';

export const theme = createTheme({
	typography,
	palette,
	breakpoints,
	spacing,
	shape: {
		borderRadius: 2,
	},
	components:{
		// MuiDateCalendar: {
		// 	styleOverrides: {
		// 	  root: {
		// 		// override generico
		// 			color: "grey", // oppure theme.palette.grey.main se vuoi usarlo dinamico
		// 			'& .MuiPickersMonth-monthButton.Mui-selected':{
		// 				backgroundColor: GREEN_LOGO+" !important"
		// 			},
		// 			'& .MuiPickersYear-yearButton.Mui-selected':{
		// 				backgroundColor: GREEN_LOGO+" !important"
		// 			},
		// 			'& .MuiPickersDay-root.Mui-selected':{
		// 				backgroundColor: GREEN_LOGO+" !important"
		// 			},
		// 			'& .MuiPickersDay-root:not(.Mui-selected)': {
		// 				// backgroundColor: GREEN_LOGO+" !important"
		// 			}
		// 		},
		// 	},
		// },
		MuiGrid:{
			styleOverrides:{
				root:{
					
				}
			}
		},
		MuiButton:{
			styleOverrides:{
				
				root:{
					height:'30px',
					width:'100%',
					"&:hover": { bgcolor: "darkgreen" },
					borderRadius:'15px',
					color: GREEN_LOGO,
					border:'2px solid green',
					fontSize:'0.9em',
					//padding:'0px',
				}
			}
		},
		// MuiSelect:{
		// 	styleOverrides:{
		// 		root:{
		// 			height:'30px',
		// 			color: GREEN_MAIN,
		// 			fontSize:'0.7em',
		// 			'& .MuiSelect-select.MuiInputBase-input.MuiInput-input': {
		// 				paddingTop: '6px',
		// 				paddingLeft:'10px',
		// 			},
					
		// 			'& .MuiSelect-icon':{
		// 				color: GREEN_MAIN
		// 			},
					
		// 			'& .MuiInputBase-root::before': {
		// 				borderBottomColor: GREEN_MAIN
		// 			},
		// 			'& .MuiInputBase-root::after': {
		// 				borderBottomColor: "darkgreen"
		// 			},
		// 		},
		// 	}
		// },
		MuiCard:{
			styleOverrides:{
				root:{
					minHeight:'50px',
					width:'100%',
					borderRadius:'5px',
					color: GREEN_MAIN,
					backgroundColor: `${GREEN_LOGO}30`,
					fontSize:'1em',
					display:'flex',
					flexDirection:'column',
					justifyContent:'center',
				}
			}
		},
		MuiIconButton:{
			styleOverrides:{
				root:{
					// bgcolor: GREEN_MAIN,
                    // "&:hover": { bgcolor: "darkgreen" },
					// color:WHITE,
					// border: "2px solid " + GREEN_MAIN
				}
			}
		},
		MuiBottomNavigationAction:{
			styleOverrides:{
				root:{
					color: GREEN_MAIN,
					"&.Mui-selected": {
						color: "darkgreen", // Colore del testo quando selezionato
					},
				}
			}
		},
		MuiCheckbox:{
			styleOverrides:{
				root:{
					'&.Mui-checked': {
						color: GREEN_LOGO,
					},
				}
			}
		},
		// MuiCheckbox:{
		// 	styleOverrides:{
		// 		root:{
		// 			'&.Mui-checked': {
		// 				color: GREEN_LOGO,
		// 			},
		// 		}
		// 	}
		// },
		MuiSelect:{
			styleOverrides:{
				root:{
					height:'30px',
					color: GREEN_MAIN,
					fontSize:'0.7em',
					'& .MuiSelect-select.MuiInputBase-input.MuiInput-input': {
						paddingTop: '6px',
						paddingLeft:'10px',
					},
					
					'& .MuiSelect-icon':{
						color: GREEN_MAIN
					},
					
					'& .MuiInputBase-root::before': {
						borderBottomColor: GREEN_MAIN,

					},
					'& .MuiInputBase-root::after': {
						borderBottomColor: "darkgreen",
					},
				},
			}
		},
		MuiTextField: {
			styleOverrides:{
				root:{
					'& .MuiInputLabel-root':{
						top:-4,
						fontSize:'1rem',
					},
					'& .MuiInputLabel-root.Mui-focused':{
						color: GREEN_MAIN
					},
					'& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
						borderColor: GREEN_LOGO,
					},
					'& .MuiOutlinedInput-input': {
						padding: '12px 12px',
						lineHeight: 1.4, 
						color:GREEN_MAIN, fontSize:'1rem',  
					},
				},
			}
		},
		MuiFormControl:{
			styleOverrides:{
				root:{
					'& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
						borderColor: GREEN_LOGO,
						color:GREEN_MAIN
					},
					'& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
						borderColor: GREEN_LOGO,
						color:GREEN_MAIN
					},
					'& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
						borderColor: GREEN_LOGO,
						color:GREEN_MAIN
					},
					'& .MuiInputLabel-root':{
						top:11,
						// color:GREEN_MAIN,
					},
					'& .MuiInputLabel-root.Mui-focused': {
						color: GREEN_MAIN,
						// top:8 
					},
				}
			}
		},
		MuiAutocomplete:{
			styleOverrides:{
				root:{
					'& .MuiOutlinedInput-root': {
						padding:'5px 9px'
					},
					'& .MuiInputLabel-root': {
						top: -4,
						
					},
				},
				popper: {
					'& .MuiAutocomplete-option':{
						fontSize:'0.8em',
						color:"grey"
					},
					'& .MuiAutocomplete-option:hover': {
					  	backgroundColor: `${GREEN_MAIN}20 !important`
					},
				},
			}
		},
		MuiPickersToolbar:{
			styleOverrides:{
				root:{
					'& .MuiTypography-root':{
						color: BLACK+" !important",
						// '& .MuiPaper-root.MuiDialog-paper':{
						// 	color: BLACK+" !important"
						// }
					}
				}
			}
		},
		MuiDateCalendar: {
			styleOverrides: {
			  root: {
				// override generico
					color: "grey", // oppure theme.palette.grey.main se vuoi usarlo dinamico
					'& .MuiPickersMonth-monthButton.Mui-selected':{
						backgroundColor: GREEN_LOGO+" !important"
					},
					'& .MuiPickersYear-yearButton.Mui-selected':{
						backgroundColor: GREEN_LOGO+" !important"
					},
					'& .MuiPickersDay-root.Mui-selected':{
						backgroundColor: GREEN_LOGO+" !important"
					},
					'& .MuiPickersDay-root:not(.Mui-selected)': {
						// backgroundColor: GREEN_LOGO+" !important"
					}
				},
			},
		},
		MuiDialogActions:{
			styleOverrides:{
				root:{
					'& .MuiButtonBase-root.MuiButton-root':{
						color: WHITE
					}
				}
			}
		}
	},
});

